export const EMAILJS_SERVICE_ID = "restia"
export const EMAILJS_CONTACT_TEMPLATE_ID = "restia-contact"
export const EMAILJS_CALCULATOR_TEMPLATE_ID = "restia-calculator"
export const EMAILJS_PUBLIC_KEY = "oh5-HDo1d8ATCASD5"
